let today_visit = new Date().getTime() 
let firstVisit = localStorage.getItem('first_visit')
  if(firstVisit !== null) {
  firstVisit = Number(firstVisit)
  }

let newUser  
let lastVisit = localStorage.getItem('last_visit')
  if(lastVisit !== null) {
  lastVisit = Number(lastVisit)
  }
// let lastVisitDays

  if(lastVisit === null && firstVisit === null) {
    localStorage.setItem('first_visit', today_visit)
    newUser = true
  } else if(lastVisit !== null && firstVisit === null) {
    let yesterday = new Date().getTime() - (1 * 24 * 60 * 60 * 1000)
    localStorage.setItem('first_visit', yesterday)
    newUser = false
  } else if (today_visit - firstVisit > 1 * 24 * 60 * 60 * 1000) {
    newUser = false
  } else {
    newUser = true
  }